function phone(phone) {
  if (!phone) return undefined
  return phone.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
}

export default phone
